// Dashboard — recent Cases only (drafts listing is per-Case in MVP).
// Per SPEC §4.5: "Dashboard Home with a stripped-down content set
// (recent Cases, recent drafts only — skip the deadlines and alerts
// surfaces)."

import { Link } from "react-router-dom";

import { cases } from "../lib/api";
import { useAsync } from "../hooks/useAsync";
import { useAuthStore } from "../lib/store";

export function DashboardPage(): JSX.Element {
  const email = useAuthStore((s) => s.email);
  const { data, loading, error } = useAsync(() => cases.list({ limit: 10 }), []);

  return (
    <div>
      <h1 className="mb-2 text-2xl font-semibold text-slate-900">Welcome back{email ? `, ${email}` : ""}.</h1>
      <p className="mb-6 max-w-prose-narrow text-sm text-slate-600">
        CaseLens organizes the documents from your matter, redacts PII at the storage boundary,
        and runs the Evidentiary Cross-Check against opposing-party documents. Pick a Case
        below or start a new one.
      </p>

      <section className="card p-5">
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-lg font-medium text-slate-800">Recent Cases</h2>
          <Link to="/cases" className="text-sm text-brand-700 underline">
            View all
          </Link>
        </div>
        {loading && <p className="text-sm text-slate-500">Loading…</p>}
        {error && (
          <p className="text-sm text-red-700">
            Could not load Cases: {error.message}
          </p>
        )}
        {data && data.cases.length === 0 && (
          <p className="text-sm text-slate-600">
            No Cases yet.{" "}
            <Link to="/cases" className="text-brand-700 underline">
              Create your first Case
            </Link>{" "}
            to start working.
          </p>
        )}
        {data && data.cases.length > 0 && (
          <ul role="list" className="divide-y divide-slate-200">
            {data.cases.slice(0, 5).map((c) => (
              <li key={c.id} className="flex items-center justify-between py-3">
                <div>
                  <Link
                    to={`/cases/${c.id}`}
                    className="font-medium text-slate-900 hover:text-brand-700"
                  >
                    {c.name}
                  </Link>
                  <div className="text-xs text-slate-500">
                    {c.case_type ? `${c.case_type} · ` : ""}
                    {c.document_count} document{c.document_count === 1 ? "" : "s"} · updated{" "}
                    {new Date(c.updated_at).toLocaleDateString()}
                  </div>
                </div>
                <Link to={`/cases/${c.id}`} className="btn-secondary">
                  Open
                </Link>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
